import React from 'react';
import { useParams } from 'react-router-dom';

import ROUTES from '@/common/routes';
import { useBreadcrumbs } from '@/modules/core/hooks';
import { useHistory } from '@/modules/core/hooks';
import ExpressSetupActivityLogs from '@/modules/ExpressSetup/ActivityLogs/ExpressSetupActivityLogs';
import { useLogOutFromExpressSetup } from '@/modules/ExpressSetup/hooks';

const ExpressSetupActivityLogsPage = () => {
  const { id } = useParams<{ id: string }>();
  const history = useHistory();
  useBreadcrumbs(
    [
      {
        title: 'Home',
        route: ROUTES.EXPRESS_SETUP_BY_ID(id),
        redirect: () => history.push(ROUTES.EXPRESS_SETUP_BY_ID(id)),
      },
      {
        route: ROUTES.EXPRESS_SETUPS_WIZARD_BY_ID(id),
        title: 'Activity Log',
      },
    ],
    undefined,
    undefined,
    true
  );
  useLogOutFromExpressSetup();

  return <ExpressSetupActivityLogs />;
};

export default ExpressSetupActivityLogsPage;
